import { useMemo } from 'react';
import { GqlVideoFragment, GqlVideoSource } from '../apollo/generated/graphql';

export const useVideoSource = (video?: GqlVideoFragment) => {
  const isExternalVideo = useMemo(() => {
    if (video) {
      const { source } = video;
      const { Vimeo, Youtube, Facebook } = GqlVideoSource;

      return [Vimeo, Youtube, Facebook].includes(source);
    }
    return false;
  }, [video]);

  return { isExternalVideo };
};
